<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header
                    :title="$t('catering_requests')"
                    :isColumns="true"
                    @filter-div-status="datatable.filterStatus = $event"
                >
                    <template v-slot:columns>
                        <div
                            class="mb-1"
                            v-for="(column, key) in datatable.columns"
                        >
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile
                    :title="$t('catering_requests')"
                    :isColumns="true"
                    @filter-div-status="datatable.filterStatus = $event"
                >
                    <template v-slot:columns>
                        <div
                            class="mb-1"
                            v-for="(column, key) in datatable.columns"
                        >
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
                :export-excel="checkPermission('cateringform_excelexport')"
                @exportExcel="downloadExcel"
            >
                <b-row>
                    <b-col cols="12" md="4">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox code="catering_form_statuses" v-model="datatable.queryParams.filter.status"/>
                        </b-form-group>
                    </b-col>
                </b-row>

            </datatable-filter>
            <datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :line-numbers="true"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </datatable>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

// Services
import CateringRequestService from "@/services/CateringRequestService";

// Others
import qs from "qs";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,
        ParameterSelectbox
    },
    metaInfo() {
        return {
            title: this.$t("catering_requests"),
        };
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("detail"),
                                class: "ri-edit-box-line",
                                permission: 'cateringform_show',
                                callback: (row) => {
                                    this.$router.push('/catering/request/' + row.id)
                                },
                            },
                        ],
                    },
                    {
                        label: this.toUpperCase("id"),
                        field: "id",
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase("employee_name"),
                        field: "employee_name",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("employee_id"),
                        field: "employee_id",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("event"),
                        field: "event_label",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("audience"),
                        field: "audience_label",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("class"),
                        field: "class_label",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("location"),
                        field: "location_label",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("event_location"),
                        field: "event_location",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("event_date"),
                        field: "event_date",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("guest_count"),
                        field: "guest_count",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("budget"),
                        field: "budget",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("dish_type"),
                        field: "dish_type_name",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("status"),
                        field: this.getLocaleField('status_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("created_at"),
                        field: "created_at",
                        hidden: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "-created_at",
                    page: 1,
                    limit: 20,
                },
            },
            formProcess: null,
            formId: null,
            form: {},
            student: null,
            available_modules: [],
        };
    },
    created() {
        this.filterSet();
        this.formClear();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {};
        },
        filterClear() {
            this.filterSet();
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) =>
                    qs.stringify(params, { encode: false }),
            };

            return CateringRequestService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;

                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        downloadExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) =>
                    qs.stringify(params, { encode: false }),
            };

            CateringRequestService.excelExport(config)
                .then((res) => this._downloadFile(res, this.$t("catering_requests") + ".xlsx"))
                .catch((err) => this.showErrors(err));
        },
        // Clear
        formClear() {
            this.formId = null;
            this.formProcess = null;
        },
    },
};
</script>
